import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { NgApexchartsModule } from 'ng-apexcharts';
import { AdminModule } from '../admin/admin.module';

// Dashboard widget components
import { EGovServicesRequestedComponent } from './components/dashboard/egov-services-requested/egov-services-requested.component';
import { EGovTaxesCollectedComponent } from './components/dashboard/egov-taxes-collected/egov-taxes-collected.component';
import { EGovTaxesPaidComponent } from './components/dashboard/egov-taxes-paid/egov-taxes-paid.component';
import { EGovTaxesUnpaidComponent } from './components/dashboard/egov-taxes-unpaid/egov-taxes-unpaid.component';
import { EGovRequestsTableComponent } from './components/dashboard/egov-requests-table/egov-requests-table.component';

@NgModule({
  declarations: [
    EGovServicesRequestedComponent,
    EGovTaxesCollectedComponent,
    EGovTaxesPaidComponent,
    EGovTaxesUnpaidComponent,
    EGovRequestsTableComponent
  ],
  exports: [
    EGovServicesRequestedComponent,
    EGovTaxesCollectedComponent,
    EGovTaxesPaidComponent,
    EGovTaxesUnpaidComponent,
    EGovRequestsTableComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    NgApexchartsModule,
    AdminModule
  ]
})
export class EGovAutomationModule { }

